export const calcularIdade = (dataNascimento) => {
  const hoje = new Date();
  const nascimento = new Date(dataNascimento);
  const diff = hoje - nascimento;

  return Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));
};
